import React from 'react';

import { NumberInput, Stack, Text } from '@mantine/core';

import { blockNonInteger, CaloriesResult } from './types';

interface CaloriesInputProps {
  value: CaloriesResult;
  onChange: (value: CaloriesResult) => void;
  enlarged?: boolean;
}

const CaloriesInput = ({ value, onChange, enlarged = false }: CaloriesInputProps): JSX.Element => (
  <Stack spacing={4}>
    <Text size={enlarged ? 'lg' : 'xs'} weight={600} color='dimmed' transform='uppercase'>
      Calories
    </Text>
    <NumberInput
      value={value.calories}
      onChange={calories => onChange({ ...value, calories })}
      min={0}
      precision={0}
      inputMode='numeric'
      onKeyDown={blockNonInteger}
      rightSection={
        <Text size={enlarged ? 'md' : 'xs'} color='dimmed' pr={8}>
          kcal
        </Text>
      }
      rightSectionWidth={48}
      size={enlarged ? 'xl' : 'md'}
    />
  </Stack>
);

export default CaloriesInput;
